import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { convertHexToRGBA } from '@utils/usefulFuncs';
import { DocumentIcon } from '@assets/icons/svgs/DocumentIcon';
import { isDocSelected } from '@utils/doc';
import { TransparentFlatButton } from '@ui/buttons';

const Wrapper = styled.div``;
const SelectableDocumentsRowWrapper = styled.div`
  margin-top: 24px;
  padding-bottom: 24px;

  display: grid;
  grid-template-columns: max-content;
  width: max-content;
  height: 80px;
`;
const SelectableActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 48px;

  button {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
`;
const SelectableDocumentWrapper = styled.div`
  &:last-child {
    //margin-bottom: 0px;
  }

  margin-bottom: 8px;
  margin-right: 16px;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  padding: 12px 16px;
  background: ${({ theme }) => convertHexToRGBA(theme.themeColors.lowContrastBorder, 1)};
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.14s;
  flex: 1;

  &:hover {
    background: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.05)};
    border: 1px solid ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.2)};

    color: ${({ theme }) => theme.themeColors.primaryCtaButton} !important;
  }

  &.selected {
    border: 1px solid ${({ theme }) => theme.themeColors.primaryCtaButton};
    background: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.2)};

    color: ${({ theme }) => theme.themeColors.buttonText} !important;
  }

  svg {
    height: 18px;
    width: 18px;
    margin-right: 8px;
    margin-left: -4px;

    fill: ${({ theme }) => theme.themeColors.text};
  }
`;

export const SelectableDocument = ({ doc, onSelect, onRemoveSelect, isSelected }) => {
  const { filename, added_by_user_id: userId } = doc;
  let className = '';
  if (isSelected) {
    className += 'selected';
  }
  if (userId) {
    className += ' user-uploaded';
  }

  return (
    <div>
      <SelectableDocumentWrapper
        className={className}
        onClick={isSelected ? () => onRemoveSelect(doc) : () => onSelect(doc)}
      >
        <DocumentIcon />
        <Body5>{filename}</Body5>
      </SelectableDocumentWrapper>
    </div>
  );
};

export const SelectableDocumentsList = ({ docs, selectedDocs, onSelect, onRemoveSelect, singleDocMode }) => {
  const handleUnselectAll = () => {
    onRemoveSelect(selectedDocs);
  };

  const handleSelectAll = () => {
    onSelect(docs);
  };

  const handleSelectAllRecentDocs = () => {
    const recent = docs.filter((d) => d).filter((d) => d.is_recent);
    if (recent.length > 0) {
      onSelect(recent);
    }
  };

  if (docs === null) {
    return null;
  }
  if (docs.length === 0) {
    return (
      <Container top={60}>
        <Body5 bold>No documents found</Body5>
      </Container>
    );
  }
  return (
    <Wrapper>
      {!singleDocMode && (
        <SelectableActionsWrapper>
          <TransparentFlatButton onClick={handleSelectAllRecentDocs}>Select All Recent Docs</TransparentFlatButton>
          <TransparentFlatButton onClick={handleSelectAll}>Select All</TransparentFlatButton>
          <TransparentFlatButton onClick={handleUnselectAll}>Unselect All</TransparentFlatButton>
        </SelectableActionsWrapper>
      )}

      <SelectableDocumentsRowWrapper>
        {docs
          .sort((a, b) => new Date(b.published_at) - new Date(a.published_at))
          .map((d) => (
            <SelectableDocument
              key={d.id}
              doc={d}
              onSelect={onSelect}
              onRemoveSelect={onRemoveSelect}
              isSelected={isDocSelected(d, selectedDocs)}
            />
          ))}
        <Container bottom={16}></Container>
      </SelectableDocumentsRowWrapper>
    </Wrapper>
  );
};
